import styled from '@emotion/styled';
import { color } from '@lightspeed/cirrus-tokens/utils';

export const Day = styled('div')(({ isToday }) => ({
  display: 'flex',
  width: '30px',
  height: '30px',
  margin: '4px',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: isToday ? '50%' : '0',
  boxShadow: isToday ? `inset 0 0 0 2px ${color('blue')}` : 'none',
}));
